import { useEffect, useState } from 'react';

interface UseMonthlyTimelineGapOptions {
  expandedMonths: string[];
  isCompact: boolean;
  laneCount: number;
  bodyWidthPx: number;
  columnsWidthPx: number;
}

/**
 * Mirrors quarterly Roadmap.tsx gap measurement: measure the right edge of the
 * timeline body (month columns + extension) against the viewport width.
 */
export function useMonthlyTimelineGap({
  expandedMonths,
  isCompact,
  laneCount,
  bodyWidthPx,
  columnsWidthPx
}: UseMonthlyTimelineGapOptions): number {
  const [gapWidth, setGapWidth] = useState(0);

  useEffect(() => {
    const calculateGap = () => {
      const monthBodies = document.querySelectorAll(
        '[data-testid="monthly-row-months-body"]'
      );

      if (monthBodies.length === 0) return;

      const lastBody = monthBodies[monthBodies.length - 1] as HTMLElement;
      const rect = lastBody.getBoundingClientRect();
      const gap = window.innerWidth - rect.right;

      setGapWidth(Math.max(gap, 0));
    };

    const timeoutId = setTimeout(calculateGap, 500);

    window.addEventListener('resize', calculateGap);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', calculateGap);
    };
  }, [expandedMonths, isCompact, laneCount, bodyWidthPx, columnsWidthPx]);

  return gapWidth;
}
